import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  question: string,
 *  answer: string,
 *  isPublished: number,
 *  lastEdited: string,
 *  pemalink: string,
 *  sortOrder: number
 *  }} Faqs
 */

const api = new Api("api/faq");

/**
 * @returns {Promise<AxiosResponse<Faqs[]>>}
 */
export const getAll = () => api.get();

export const remove = (permalink) => api.del(permalink);

export const create = (payload) => api.post("", payload);

/**
 * @param {string} permalink
 * @returns {Promise<AxiosResponse<Faqs>>}
 */
export const getByPermalink = (permalink) => api.get(permalink);

export const update = (permalink, payload) => api.putId(permalink, payload);
